/*
 *   Roles:
 *   business_manager - Manažer obchodu - MO
 *   business_real_estate_specialist - Realitní specialista obchod - RSO
 *   head_lawyer - Vedoucí právník - VP
 *   deputy_head_lawyer - Zástupce vedoucího právníka - ZVP
 *   lawyer - Právník - P
 *   legal_department_assistant - Asistentka právního oddělení - APO
 *   statutory - Jednatel - J
 *   accounting_supervisor - Účetní kontrolor - UK
 *   client_change_manager - Manažer klientských změn - MKZ
 *   admin - Admin - A
 * */

export const MO = 'business_manager'
export const RSO = 'business_real_estate_specialist'
export const VP = 'head_lawyer'
export const ZVP = 'deputy_head_lawyer'
export const P = 'lawyer'
export const APO = 'legal_department_assistant'
export const J = 'statutory'
export const UK = 'accounting_supervisor'
export const MKZ = 'client_change_manager'
export const A = 'admin'

export const ALL_ROLES = [MO, RSO, VP, ZVP, P, APO, J, UK, MKZ, A] as const

export type Role = (typeof ALL_ROLES)[number]

export const REQUEST_DOCUMENTATION_USER_ROLES = [
  VP,
  ZVP,
  P,
  APO,
  J,
  RSO,
  MO,
  MKZ,
  A,
] as const

export const REQUEST_LEASE_USER_ROLES = [
  VP,
  ZVP,
  P,
  APO,
  J,
  RSO,
  MO,
  MKZ,
  A,
] as const

export const REQUEST_LEASE_MANAGER_ROLES = [MO, MKZ, A] as const

export const REQUEST_LEASE_ASSISTANT_ROLES = [P, VP, ZVP, APO, A] as const

export const REQUEST_APPROVAL_USER_ROLES = [VP, ZVP, P, APO, J, UK, A] as const

export const REQUEST_APPROVAL_ASSIGNEE_ROLES = [VP, ZVP, P, J, A, APO] as const
